import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Encounter, EncounterPhase } from 'src/models';
import { ambientApi } from 'src/services';

export type UseStartEncounterMutationParams = {
  encounterId: string;
  encounterPhase: EncounterPhase;
  payload: Partial<{
    template_id: string | null;
    template_overrides_id: string | null;
  }>;
};

export type StartEncounterResponse = {
  encounter: Encounter;
};

export const useStartEncounter = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['startEncounter'],
    mutationFn: ({
      encounterId,
      encounterPhase,
      payload,
    }: UseStartEncounterMutationParams) =>
      ambientApi.post<StartEncounterResponse>(
        `/encounters/${encounterId}/start`,
        payload,
        {
          params: {
            encounter_phase: encounterPhase,
          },
        }
      ),
    onSuccess: (_, payload) => {
      // Invalidate and refetch encounter details
      queryClient.invalidateQueries({
        queryKey: ['encounterDetails', payload.encounterId],
      });

      // Invalidate encounter list queries
      queryClient.invalidateQueries({ queryKey: ['encounterList'] });
    },
  });
};
